import type { PortfolioMetric } from "./portfolio-selectors";

export const portfolioQty = new Intl.NumberFormat("en-GB", { maximumFractionDigits: 3 });
const money = new Intl.NumberFormat("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export function Metric({ metric, euro = false, net = false, compact = false }: { metric: PortfolioMetric; euro?: boolean; net?: boolean; compact?: boolean }) {
  const absolute = Math.abs(metric.value ?? 0);
  // Opposing lots can leave floating-point dust. Do not label a displayed zero
  // as a positive/negative exposure after formatting to cents (or 0.001 MWh).
  const displayedZero = absolute < (euro || compact ? 0.005 : 0.0005);
  const sign = displayedZero ? "" : metric.value != null && metric.value < 0 ? "−" : net && metric.value != null && metric.value > 0 ? "+" : "";
  const amount = compact ? `€${absolute >= 1e6 ? `${(absolute / 1e6).toFixed(2)}m` : money.format(absolute)}` : euro ? money.format(absolute) : portfolioQty.format(absolute);
  const incompleteNet = metric.value == null;
  const unavailable = incompleteNet || metric.missing > 0 && !metric.present;
  const value = unavailable ? "—" : `${sign}${amount}`;
  const exact = compact && !unavailable ? `${sign}${money.format(absolute)} EUR` : "";
  const coverage = metric.missing ? `${metric.missing} contribution(s) lack required inputs. ${incompleteNet ? "Net notional requires complete pricing and direction." : "Available subtotal only."}` : "";
  return <span className="portfolio-number" title={[exact, coverage].filter(Boolean).join(" · ") || undefined}>
    {value}{metric.missing > 0 && <small className="portfolio-partial"> {incompleteNet ? "Unavailable" : "Partial"}</small>}
  </span>;
}
